import React from 'react';
import classNames from 'classnames/bind';
import { BannerGroup } from '@carnica/ui-kit';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect } from "../../../utils";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _CarouselBannerGroup = function _CarouselBannerGroup(_ref) {
  var children = _ref.children,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 3000 : _ref$duration,
    className = _ref.className,
    _ref$autoPlay = _ref.autoPlay,
    autoPlay = _ref$autoPlay === void 0 ? true : _ref$autoPlay,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? true : _ref$loop,
    anchorId = _ref.anchorId,
    _ref$withControls = _ref.withControls,
    withControls = _ref$withControls === void 0 ? false : _ref$withControls,
    invertBar = _ref.invertBar;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('carousel-banner-group', className),
    id: anchorId,
    "data-t-id": "Carousel-CarouselBannerGroup"
  }, /*#__PURE__*/React.createElement(BannerGroup, {
    autoPlay: autoPlay,
    className: cx('carousel-swiper'),
    duration: duration,
    invertBar: invertBar,
    loop: loop,
    progressBarClassName: cx('carousel-dots'),
    withControls: withControls
  }, children));
};
export var CarouselBannerGroup = compose(enhancedConnect(), withAutoMetric.Element(function (props) {
  return {
    id: props.anchorId,
    name: 'CarouselBannerGroup'
  };
}))(_CarouselBannerGroup);